import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_search",
  "use": "svg_search-usage",
  "viewBox": "0 0 17.9 17.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.9 17.9\" id=\"svg_search\"><path fill=\"currentColor\" d=\"m17.89 17.1-6-6a6.67 6.67 0 0 0 1.6-4.35 6.76 6.76 0 1 0-2.38 5.17l6 6ZM6.75 12.37a5.63 5.63 0 1 1 5.63-5.62 5.62 5.62 0 0 1-5.63 5.62Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol